import React from 'react';

const CardEvent = ({
  title,
  timeText,
  borderColor = '#607d8b',
  viewType,
  start,
  end,
  status,
}) => {
  const [customer, service] = title.includes(' – ') ? title.split(' – ') : [title, ''];
  const durationInMinutes = (new Date(end) - new Date(start)) / 60000;
  const isMonth = viewType === 'dayGridMonth';

  // ⏰ Αν έχει λήξει και δεν έχει explicit status → θεωρείται "Ολοκληρώθηκε"
  const now = new Date();
  const hasEnded = new Date(end) < now;
  const effectiveStatus = !status && hasEnded ? 'completed' : status || '';

  // 🏷️ Mapping status → text + χρώμα φόντου
  const statusMap = {
    cancelled: { text: '❌ Ακυρώθηκε', bg: 'bg-red-100 text-red-700 border border-red-200' },
    no_show: { text: '🚫 Δεν ήρθε', bg: 'bg-yellow-100 text-yellow-700 border border-yellow-200' },
    completed: { text: '✅ Ολοκληρώθηκε', bg: 'bg-green-100 text-green-700 border border-green-200' },
    '': { text: '', bg: '' },
  };

  const { text: statusText, bg } = statusMap[effectiveStatus] || statusMap[''];

  return (
    <div
      className={`rounded ${
        isMonth
          ? 'bg-indigo-100 text-xs px-1 truncate'
          : 'bg-white shadow px-1 py-[2px] text-xs'
      } flex flex-col justify-center h-full`}
      style={{
        borderLeft: `4px solid ${borderColor}`,
        lineHeight: 1.2,
        minHeight: '40px',
        overflow: 'hidden',
      }}
    >
      {/* Πελάτης */}
      {customer && (
        <div className="font-medium leading-tight text-gray-900 truncate text-[12px]">
          {customer}
        </div>
      )}

      {/* Ώρα + Κατάσταση στην ίδια γραμμή */}
      {!isMonth && (
        <div className="flex items-center justify-between mt-[1px]">
          {timeText && (
            <div className="text-[11px] text-gray-600 truncate">{timeText}</div>
          )}
          {statusText && (
            <div
              className={`ml-1 rounded-full px-2 py-[1px] text-[10px] font-medium whitespace-nowrap ${bg}`}
            >
              {statusText}
            </div>
          )}
        </div>
      )}

      {/* Υπηρεσία (μόνο αν έχει διάρκεια ≥ 45 λεπτά) */}
      {!isMonth && service && durationInMinutes >= 45 && (
        <div className="text-[11px] text-gray-500 leading-tight truncate mt-[1px]">
          {service}
        </div>
      )}
    </div>
  );
};

export default CardEvent;
